/* eslint-disable react/jsx-no-useless-fragment */
import { Box, Radio, Tooltip, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import Iconify from '../../../fl-components/Iconify';

export default function TypeTestView({ testDetails, submissionDetails, currentUser }) {
  return (
    <>
      {testDetails.type === 'type' && (
        <>
          <Typography mb={1} fontSize={22} fontWeight="bold">
            {currentUser.profile === 'student' ? 'Your Answer Sheet' : 'Student Answers'}
          </Typography>
          {submissionDetails?.questionsAndAnswers.map((qAns, i) => (
            <Box mb={3} key={i}>
              <Typography variant="h5">
                {i + 1}. {qAns.name}
              </Typography>
              {qAns.options.map((obj, i) => (
                <Box
                  sx={{
                    display: 'flex',
                    border: '1px solid rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'rgba(0, 0, 0, 0.03)',
                    borderRadius: 8,
                    alignItems: 'center',
                    margin: '10px 0',
                    alignContent: 'space-between',
                    width: '100%'
                  }}
                  key={i}
                  pr={1}
                >
                  <Box flex={1} display="flex" alignItems="center">
                    <Radio checked={obj.isSelected} disabled={!obj.isSelected} />
                    <Typography>{obj.value}</Typography>
                  </Box>
                  {obj.isAnswer && (
                    <Tooltip title="Correct answer" placement="top">
                      <Box display="flex">
                        <Iconify
                          icon="bi:check-circle-fill"
                          width={18}
                          height={18}
                          sx={{ color: '#00d383' }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Box>
              ))}
            </Box>
          ))}
        </>
      )}
    </>
  );
}

TypeTestView.propTypes = {
  testDetails: PropTypes.object,
  submissionDetails: PropTypes.object,
  currentUser: PropTypes.object
};
